import React from 'react';
import { FormattedMessage } from 'react-intl';
import elements from 'components/elements';

import { ButtonGroupStyled } from 'pages/dokkaPay/pages/company/components/PaymentPreview/components/StyledComponents';
import Button from '@mui/material/Button';
import RouterLink from 'components/mui/Router/RouterLink';

import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';

interface PreviewActionGroupProps {
  onClickLink?: React.MouseEventHandler<HTMLElement>;
  href: string;
  withContext: boolean;
  onClickContextMenu: (e: React.MouseEvent) => void;
  isContextMenuOpen: boolean;
  contextMenuRef: React.Ref<HTMLButtonElement>;
}

const PreviewActionGroup: React.FC<PreviewActionGroupProps> = ({
  onClickLink,
  href,
  withContext,
  onClickContextMenu,
  isContextMenuOpen,
  contextMenuRef,
}) => {
  const handleContextMenuClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClickContextMenu(e);
  };

  return (
    <ButtonGroupStyled
      variant="contained"
      color="primary"
      data-element={elements.content.documents.preview.actions.group}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <Button
        classes={{ root: 'previewAction-link' }}
        component={RouterLink as any}
        href={href}
        onClick={onClickLink}
        data-element={elements.content.documents.preview.actions.open}
      >
        <FormattedMessage id="documents.item.preview.open" defaultMessage="Open" />
      </Button>
      {withContext && (
        <Button
          classes={{ root: 'previewAction-button' }}
          size="small"
          onClick={handleContextMenuClick}
          ref={contextMenuRef}
          data-element={elements.content.documents.preview.actions.context}
        >
          {isContextMenuOpen ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
        </Button>
      )}
    </ButtonGroupStyled>
  );
};

export default PreviewActionGroup;
